<template>
  <div class="area">
    <span>Zone géo.</span>
    <select @change="$emit('change', $event)">
      <option value="0">-- Toutes --</option>
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.nameFr+' ['+item.id+']'">{{ item.nameFr }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersCompetitionArea',
  computed: {
    items () { return this.$store.getters['Main/Area/list'] }
  }
}
</script>

<style scoped>
  .area{
    display:flex;
    height:20px;
    align-items:center;
    margin-bottom:10px
  }
  .area > span{
    font-size:14px
  }
  .area > select{
    height:18px;
    margin-left:5px
  }
</style>
